import React from 'react';
import { Alert } from '@mui/material';
import { AccountTree as TreeIcon } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

interface OwnProfileBannerProps {
  personId: string;
}

/**
 * Shows banner when user is viewing their own linked person profile
 */
const OwnProfileBanner: React.FC<OwnProfileBannerProps> = ({ personId }) => {
  const { authState } = useAuth();
  const user = authState.user;

  // Only show if user is linked to this person
  if (!user || user.personId !== personId) {
    return null;
  }

  return (
    <Alert severity="info" icon={<TreeIcon />} sx={{ mb: 2 }}>
      <strong>This is your Family Tree Profile.</strong> You can edit this profile,
      and all changes will be submitted for admin approval.
    </Alert>
  );
};

export default OwnProfileBanner;
